import { render, staticRenderFns } from "./DestinationTagInput.vue?vue&type=template&id=09e7a325"
import script from "./DestinationTagInput.vue?vue&type=script&lang=js"
export * from "./DestinationTagInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports